
function isInViewPort(element) {
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;
    const {
        top,
        bottom,
    } = element.getBoundingClientRect();

    return (
        (top >= 0 &&
            top <= viewHeight) || (bottom >= 0 && bottom <= viewHeight)
    );
}

"use strict";

/**
 * 表单校验
 * @param { 表单Id } formId
 * @param { 输入框name} field
 * @param { name : [ { required, error, regex }] } formRule 表单校验规则
 */
var formValidator = function formValidator(formId, formRule) {

  var isValid = true;
  try {
    Object.keys(formRule).forEach(function (key) {

      isValid = validField(formId, key, formRule[key]);

      if (!isValid) {
        throw Error();
      }
    });
  } catch (error) {}
  return isValid;
};

/**
 * 单个field校验
 * @param {*} rule  [ { required, error, regex ... }]
 */
var validField = function validField(formId, field, rule) {
  //  目标选择器名称
  var selectorName = "#" + formId + " input[name='" + field + "']";
  //  目标对象
  var target = $(selectorName);

  var value = target.val();

  var errorMsg = "";
  try {
    rule.forEach(function (item) {
      if (item.required && !value) {
        errorMsg = item.error;

        throw Error();
      } else if (item.min || item.max) {
        if (value.length < item.min || item.max < value.length) {
          errorMsg = item.error;

          throw Error();
        }
      } else if (item.regex) {
        var reg = new RegExp(item.regex);

        if (!reg.test(value)) {
          errorMsg = item.error;

          throw Error();
        }
      }
    });
  } catch (error) {}
  if (errorMsg) {
    target.parents(".form-item").addClass("is-error").find(".form-error").text(errorMsg);
    return false;
  }
  return true;
};

/**
 * 获取焦点 删除表单提示
 * @param {*} event 
 */
var onFieldFocus = function(event) {
    $(event).parents(".form-item").removeClass("is-error").find(".form-error").text('');
}
